// extracted by mini-css-extract-plugin
export default {"loader":"communityPostPage_loader__uOpdZ","stripes-animation-background-keyframes":"communityPostPage_stripes-animation-background-keyframes__zbbK4"};